import { useEffect, useState } from "react";
import axios from "axios";
import { Megaphone, Plus } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/components/bulk/common";
import { CampaignCard } from "@/components/bulk/CampaignCard";
import { CampaignModal } from "@/components/bulk/CampaignModal";

export function CampaignList({ info, onChanged }) {
  const [rows, setRows] = useState(null), [modal, setModal] = useState(null);
  const load = () => axios.get(`${API}/campaigns`).then((r) => setRows(r.data)).catch(() => toast.error("Kampanyalar yüklenemedi"));
  const refresh = () => { load(); onChanged(); };
  useEffect(() => { load(); }, []);
  const active = !!rows?.some((c) => c.status === "sending");
  useEffect(() => { if (!active) return undefined; const t = setInterval(refresh, 8000); return () => clearInterval(t); }, [active]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <div className="bulk-head"><div><h3>Kampanyalar</h3><p>Taslak, zamanlanmış ve gönderilmiş toplu mesajlarınız</p></div>
        <button className="primary-btn" onClick={() => setModal({})} data-testid="new-campaign-button"><Plus size={16} />Yeni kampanya</button></div>
      {!rows ? <p className="empty" data-testid="campaigns-loading">Yükleniyor…</p> : rows.length === 0 ? (
        <div className="panel campaigns-empty" data-testid="campaigns-empty"><Megaphone size={26} /><b>Henüz kampanya yok</b><p>Örneğin "29 Ekim Cumhuriyet Bayramı" adıyla bir kampanya oluşturun, görselini yükleyin ve gönderim saatini seçin.</p></div>
      ) : <div className="campaign-list">{rows.map((c) => <CampaignCard key={c.id} c={c} onEdit={() => setModal(c)} onChanged={refresh} />)}</div>}
      {modal && <CampaignModal initial={modal.id ? modal : null} info={info} onClose={() => { setModal(null); load(); }} onSaved={() => { setModal(null); refresh(); }} />}
    </>
  );
}
